import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

var _this = this;

import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import { connect, ReactReduxContext } from 'react-redux';
import { CATALOGUETYPES } from "../../constants";
import { Container, Row, Col } from 'react-bootstrap';
import Heading from '../heading/Heading';
import ImageLoader from '../images/ImageLoader';
import { capitalizeObjEntries, mobileAppUtil } from '../../util'; // Redux

import { accountDuck } from "../../ducks/account";
import ReturnsModalForm from "../retail/returns/ReturnsModalForm";
import * as UTIL from "../../util";
import { Loading } from "../state";
import moment from "moment";
import MediaQuery from "react-responsive";
var accountOperations = accountDuck.operations;

var AccountOrders = function AccountOrders(props) {
  var isLoading = props.isLoading,
      _props$orders = props.orders,
      orders = _props$orders === void 0 ? [] : _props$orders,
      _props$getAccountOrde = props.getAccountOrders,
      getAccountOrders = _props$getAccountOrde === void 0 ? function () {
    return console.log('Get account orders');
  } : _props$getAccountOrde,
      isGuest = props.isGuest,
      _props$responseGuestO = props.responseGuestOrder,
      responseGuestOrder = _props$responseGuestO === void 0 ? function () {
    return "";
  } : _props$responseGuestO,
      _props$toReturn = props.toReturn,
      toReturn = _props$toReturn === void 0 ? function () {
    return "";
  } : _props$toReturn,
      _props$setShowReplace = props.setShowReplacement,
      setShowReplacement = _props$setShowReplace === void 0 ? function () {
    return "";
  } : _props$setShowReplace,
      _props$showReplacemen = props.showReplacement,
      showReplacement = _props$showReplacemen === void 0 ? function () {
    return "";
  } : _props$showReplacemen,
      token = props.token,
      _props$reOrderItems = props.reOrderItems,
      reOrderItems = _props$reOrderItems === void 0 ? function () {
    return console.log('Order Again');
  } : _props$reOrderItems,
      _props$addLineFromOrd = props.addLineFromOrder,
      addLineFromOrder = _props$addLineFromOrd === void 0 ? function () {
    return console.log('Order Again for one line item');
  } : _props$addLineFromOrd,
      _props$setReOrderSucc = props.setReOrderSuccess,
      setReOrderSuccess = _props$setReOrderSucc === void 0 ? function () {
    return "";
  } : _props$setReOrderSucc,
      reOrderSuccess = props.reOrderSuccess;
  var layout = {
    background: 'solid',
    padding: 'medium'
  };
  var title = 'My Orders';
  var history = useHistory();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      currentOrder = _useState2[0],
      setCurrentOrder = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showOrderDetails = _useState4[0],
      setShowOrderDetails = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      OrderAgainActionclicked = _useState6[0],
      setOrderAgainAction = _useState6[1];

  useEffect(function () {
    if (!isGuest && !showOrderDetails && (token === null || token === void 0 ? void 0 : token.jwtIdToken)) {
      getAccountOrders();
      setReOrderSuccess(false);
    }
  }, [token === null || token === void 0 ? void 0 : token.jwtIdToken, showOrderDetails]);
  useEffect(function () {
    if (Array.isArray(orders) && orders.length === 1) {
      setCurrentOrder(orders[0]);
      setShowOrderDetails(true);
    }
  }, [orders]);
  useEffect(function () {
    if (!isGuest && reOrderSuccess && OrderAgainActionclicked) {
      history.push('/cart');
    }
  }, [reOrderSuccess, OrderAgainActionclicked]);
  if (UTIL.mobileAppUtil.isMobileApp()) return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReturnsModalForm, {
    store: props === null || props === void 0 ? void 0 : props.store,
    show: showReplacement,
    hide: function hide() {
      return setShowReplacement(false);
    }
  }), !showOrderDetails ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: {
      value: title
    },
    className: "cb-account__title"
  }), !isLoading && orders.length ? orders.map(function (item, index) {
    var Item = capitalizeObjEntries(item);
    return /*#__PURE__*/React.createElement(OrderCard, {
      key: "order-".concat(index),
      item: Item,
      viewDetailsActionCopy: "View Details",
      viewDetailsAction: function viewDetailsAction(e) {
        setReOrderSuccess(false);
        setCurrentOrder(Item);
        setShowOrderDetails(true);
      },
      orderAgainActionCopy: "Order Again",
      orderAgainAction: function orderAgainAction(e) {
        reOrderItems(Item === null || Item === void 0 ? void 0 : Item.OrderNumber);
        setOrderAgainAction(true);
      }
    });
  }) : /*#__PURE__*/React.createElement("div", null, !isLoading && /*#__PURE__*/React.createElement("p", null, "You don't have any past orders."), isLoading && /*#__PURE__*/React.createElement(Loading, {
    isLoading: true
  }))) : /*#__PURE__*/React.createElement("div", null, !isGuest && /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "cb-account-card__back",
    onClick: function onClick(e) {
      e.preventDefault();
      setShowOrderDetails(false);
    }
  }, "Back to orders"), isGuest && /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "cb-account-card__back",
    onClick: function onClick(e) {
      e.preventDefault();
      responseGuestOrder();
    }
  }, "Find Different Order"), /*#__PURE__*/React.createElement(CurrentOrder, {
    order: currentOrder,
    isGuest: isGuest,
    returnAction: function returnAction(item) {
      setShowReplacement(true);
      toReturn(item);
    },
    topAction: function topAction(orderId, lineId) {
      addLineFromOrder(orderId, lineId);
      setOrderAgainAction(true);
    }
  })));
  return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReturnsModalForm, {
      store: props === null || props === void 0 ? void 0 : props.store,
      show: showReplacement,
      hide: function hide() {
        return setShowReplacement(false);
      }
    }), !showOrderDetails ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, {
      level: "2",
      field: {
        value: title
      },
      className: "cb-account__title"
    }), !isLoading && orders.length ? orders.map(function (item, index) {
      var Item = capitalizeObjEntries(item);
      return /*#__PURE__*/React.createElement(OrderCard, {
        key: "order-".concat(index),
        item: Item,
        viewDetailsActionCopy: "View Details",
        viewDetailsAction: function viewDetailsAction(e) {
          setReOrderSuccess(false);
          setCurrentOrder(Item);
          setShowOrderDetails(true);
        },
        orderAgainActionCopy: "Order Again",
        orderAgainAction: function orderAgainAction(e) {
          reOrderItems(Item === null || Item === void 0 ? void 0 : Item.OrderNumber);
          setOrderAgainAction(true);
        }
      });
    }) : /*#__PURE__*/React.createElement("div", null, !isLoading && /*#__PURE__*/React.createElement("p", null, "You don't have any past orders."), isLoading && /*#__PURE__*/React.createElement(Loading, {
      isLoading: true
    }))) : /*#__PURE__*/React.createElement("div", null, !isGuest && /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "cb-account-card__back",
      onClick: function onClick(e) {
        e.preventDefault();
        setShowOrderDetails(false);
      }
    }, "Back to orders"), isGuest && /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "cb-account-card__back",
      onClick: function onClick(e) {
        e.preventDefault();
        responseGuestOrder();
      }
    }, "Find Different Order"), /*#__PURE__*/React.createElement(CurrentOrder, {
      order: currentOrder,
      isGuest: isGuest,
      returnAction: function returnAction(item) {
        setShowReplacement(true);
        toReturn(item);
      },
      topAction: function topAction(orderId, lineId) {
        addLineFromOrder(orderId, lineId);
        setOrderAgainAction(true);
      }
    })));
  }.bind(_this));
};

var OrderCard = function OrderCard(props) {
  var item = props.item,
      _props$viewDetailsAct = props.viewDetailsAction,
      viewDetailsAction = _props$viewDetailsAct === void 0 ? function () {
    return "";
  } : _props$viewDetailsAct,
      viewDetailsActionCopy = props.viewDetailsActionCopy,
      _props$orderAgainActi = props.orderAgainAction,
      orderAgainAction = _props$orderAgainActi === void 0 ? function () {
    return "";
  } : _props$orderAgainActi,
      orderAgainActionCopy = props.orderAgainActionCopy;
  var title = "".concat(item.OrderDate || item.SubmittedDate, " | $").concat(item.Price.Total);
  var mobileFormatedDate = moment(item.OrderDate).format('MM/DD/YY');
  var mobileTitle = "".concat(mobileFormatedDate, " | $").concat(item.Price.Total);
  var orderNumber = "Order # ".concat(item.OrderNumber, " | ").concat(item.Status);
  var items = item.CartLines || item.Items || [];
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__header"
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, /*#__PURE__*/React.createElement("h3", null, mobileTitle)), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement("h3", null, title)), /*#__PURE__*/React.createElement("div", {
    className: "account-button-group"
  }, viewDetailsActionCopy ? /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      if (typeof viewDetailsAction === 'undefined') {
        return false;
      }

      return viewDetailsAction();
    },
    className: "cb-button-secondary"
  }, viewDetailsActionCopy) : null)), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, orderNumber), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, items.map(function (item, index) {
    var Item = capitalizeObjEntries(item);
    return /*#__PURE__*/React.createElement(Col, {
      md: "auto",
      key: "cart-item-".concat(index)
    }, /*#__PURE__*/React.createElement(Card, {
      item: Item
    }));
  })))));
};

var Card = function Card(props) {
  var item = props.item,
      _props$full = props.full,
      full = _props$full === void 0 ? false : _props$full,
      _props$topAction = props.topAction,
      topAction = _props$topAction === void 0 ? function () {
    console.log('action');
  } : _props$topAction,
      _props$returnAction = props.returnAction,
      returnAction = _props$returnAction === void 0 ? function () {
    console.log('returnAction');
  } : _props$returnAction;
  var _item$Product = item.Product,
      Product = _item$Product === void 0 ? {} : _item$Product,
      ReturnDetails = item.ReturnDetails;
  var DisplayName = Product.DisplayName,
      ImageFilePath = Product.ImageFilePath,
      CatalogName = Product.CatalogName;
  var IsReturnInitiated = ReturnDetails.IsReturnInitiated,
      Reason = ReturnDetails.Reason,
      returnQty = ReturnDetails.Quantity,
      ReturnWindowExpired = ReturnDetails.ReturnWindowExpired,
      Status = ReturnDetails.Status;
  var image = {
    'value': {
      'src': ImageFilePath || "",
      'alt': DisplayName,
      'title': DisplayName
    }
  };
  var isRetail = CatalogName === CATALOGUETYPES.retail;
  return /*#__PURE__*/React.createElement(Row, {
    className: "\n    cb-account-order__item\n    ".concat(full ? 'cb-account-order__item--detail' : '', "\n    ")
  }, /*#__PURE__*/React.createElement(Col, {
    className: full ? "d-flex" : ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order__item-image"
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    isEditing: false,
    media: image,
    className: "cb-card__image cb-card__image--contain"
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order__item-description"
  }, /*#__PURE__*/React.createElement("p", null, item.Product.DisplayName), /*#__PURE__*/React.createElement("p", {
    className: "mt-16"
  }, Boolean(item.TrackingNumber) ? "Tracking Number: ".concat(item.TrackingNumber) : null), IsReturnInitiated && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "mt-16"
  }, "Return Status: ", Status), /*#__PURE__*/React.createElement("form", {
    method: "POST",
    action: "https://row.ups.com/GuestAccess/Guest/Access",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "Company",
    value: "Q0I="
  }), /*#__PURE__*/React.createElement("input", {
    type: "submit",
    className: "cb-button-unstyled cb-button-link",
    value: "Print your shipping label here"
  }))))), full ? /*#__PURE__*/React.createElement(Col, {
    lg: "3",
    sm: "12",
    className: "cb-account-order__item-actions"
  }, isRetail && !IsReturnInitiated && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      if (typeof returnAction === 'undefined') {
        return false;
      }

      return returnAction(item);
    },
    className: "cb-button-secondary mt-16",
    style: {
      paddingRight: 0,
      paddingLeft: 0
    }
  }, "Return")) : null);
};

var CurrentOrder = function CurrentOrder(props) {
  var _order$BillingInfo, _order$BillingInfo$Bi;

  var order = props.order,
      isGuest = props.isGuest,
      _props$returnAction2 = props.returnAction,
      _returnAction = _props$returnAction2 === void 0 ? function () {
    return "";
  } : _props$returnAction2,
      _props$topAction2 = props.topAction,
      topAction = _props$topAction2 === void 0 ? function () {
    return "";
  } : _props$topAction2;

  var Status = order.Status,
      Price = order.Price;
  var title = "Order # ".concat(order.OrderNumber);
  var orderTitle = "Ordered on ".concat(order.OrderDate);
  var shippingAddress = Array.isArray(order.Addresses) ? order.Addresses[0] : order === null || order === void 0 ? void 0 : (_order$BillingInfo = order.BillingInfo) === null || _order$BillingInfo === void 0 ? void 0 : (_order$BillingInfo$Bi = _order$BillingInfo.BillingContact) === null || _order$BillingInfo$Bi === void 0 ? void 0 : _order$BillingInfo$Bi.Address;
  var items = order.CartLines || order.Items;

  var actionForLineItem = function actionForLineItem(lineId) {
    topAction(order.Id, lineId);
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: {
      value: title
    },
    className: "cb-account__title"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__header"
  }, /*#__PURE__*/React.createElement("h3", null, orderTitle)), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order__container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "3"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Status:")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, Status))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Total:")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, "$", Price.Total))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Shipping to:"), /*#__PURE__*/React.createElement("p", null, shippingAddress.Address1, /*#__PURE__*/React.createElement("br", null), shippingAddress.City, ", ", shippingAddress.State, " ", shippingAddress.ZipPostalCode)), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Container, null, items.map(function (item, index) {
    var Item = capitalizeObjEntries(item);
    return /*#__PURE__*/React.createElement(Row, {
      key: "cart-item-".concat(index),
      className: "cb-account-order__divider"
    }, /*#__PURE__*/React.createElement(Col, {
      key: "cart-item-".concat(index)
    }, /*#__PURE__*/React.createElement(Card, {
      item: Item,
      full: true,
      topAction: function topAction(e) {
        actionForLineItem(Item.Id);
      },
      returnAction: function returnAction(e) {
        e.orderNumber = order.OrderNumber;

        _returnAction(e);
      }
    })));
  })))))));
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$account, _state$account2, _state$account3, _state$account4, _state$account5;

  return {
    orders: (_state$account = state.account) === null || _state$account === void 0 ? void 0 : _state$account.orders,
    isLoading: (_state$account2 = state.account) === null || _state$account2 === void 0 ? void 0 : _state$account2.isLoading,
    showReplacement: (_state$account3 = state.account) === null || _state$account3 === void 0 ? void 0 : _state$account3.showReplacement,
    isError: state.error.isError,
    err: state.error.err,
    token: (_state$account4 = state.account) === null || _state$account4 === void 0 ? void 0 : _state$account4.aadResponse,
    reOrderSuccess: (_state$account5 = state.account) === null || _state$account5 === void 0 ? void 0 : _state$account5.reOrderSuccess
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getAccountOrders: function getAccountOrders() {
      return dispatch(accountOperations.getAccountOrders());
    },
    responseGuestOrder: function responseGuestOrder() {
      return dispatch(accountOperations.responseGuestOrder({
        orders: []
      }));
    },
    toReturn: function toReturn(item) {
      return dispatch(accountOperations.toReturn(item));
    },
    setShowReplacement: function setShowReplacement(el) {
      return dispatch(accountOperations.setShowReplacement(el));
    },
    reOrderItems: function reOrderItems(orderId) {
      return dispatch(accountOperations.reOrderItems(orderId));
    },
    setReOrderSuccess: function setReOrderSuccess(success) {
      return dispatch(accountOperations.responseReOrder(success));
    },
    addLineFromOrder: function addLineFromOrder(orderId, lineId) {
      return dispatch(accountOperations.addLineFromOrder(orderId, lineId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountOrders);